import type { UserPreferencesPayload } from '~/utils/userPreferences/types'
import { parseUserPreferencesJson, normalizeUserPreferencesPayload } from '~/utils/userPreferences/normalizeUserPreferences'

export const USER_PREFS_STORAGE_KEY = 'monorga.userPrefs'
export const USER_PREFS_COOKIE_KEY = 'monorga_prefs_cache'
export const USER_PREFS_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30

export function readPrefsFromLocalStorage(): UserPreferencesPayload | null {
  if (!import.meta.client) {
    return null
  }
  try {
    const raw = localStorage.getItem(USER_PREFS_STORAGE_KEY)
    if (!raw) {
      return null
    }
    const parsed = parseUserPreferencesJson(raw)
    return normalizeUserPreferencesPayload(parsed)
  } catch {
    return null
  }
}

export function readPrefsFromCookie(cookieValue: unknown): UserPreferencesPayload | null {
  if (cookieValue === null || cookieValue === undefined) {
    return null
  }
  if (typeof cookieValue === 'string') {
    if (cookieValue.trim() === '') {
      return null
    }
    return normalizeUserPreferencesPayload(parseUserPreferencesJson(cookieValue))
  }
  if (typeof cookieValue === 'object') {
    return normalizeUserPreferencesPayload(cookieValue)
  }
  return null
}

export function preferNewestLocalPrefs(
  cookiePrefs: UserPreferencesPayload | null,
  storagePrefs: UserPreferencesPayload | null,
): UserPreferencesPayload | null {
  if (cookiePrefs && storagePrefs) {
    return cookiePrefs.updatedAt >= storagePrefs.updatedAt ? cookiePrefs : storagePrefs
  }
  return cookiePrefs ?? storagePrefs
}

export function writePrefsToLocalStorage(prefs: UserPreferencesPayload): void {
  if (!import.meta.client) {
    return
  }
  try {
    localStorage.setItem(USER_PREFS_STORAGE_KEY, JSON.stringify(prefs))
  } catch {
    /* quota / mode privé */
  }
}

export function writePrefsToCookie(
  prefs: UserPreferencesPayload,
  writeCookie: (value: UserPreferencesPayload) => void,
): void {
  if (!import.meta.client) {
    return
  }
  try {
    writeCookie(prefs)
  } catch {
    /* cookie trop volumineux */
  }
}
